import { render, staticRenderFns } from "./RenovacionManualDialog.vue?vue&type=template&id=255a9cf5"
import script from "./RenovacionManualDialog.vue?vue&type=script&lang=js"
export * from "./RenovacionManualDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports